import { SiDiscord } from '@icons-pack/react-simple-icons';
import TooltipButton from './Tooltip';

export const DiscordProfileLink = ({ id }: { id: string | null }) => {
    return (
        <TooltipButton
            text={`Open discord profile (might not work depending on your OS or their privacy settings). Discord ID: ${id}`}
            side="top"
        >
            <a href={`discord://-/users/${id}`}>
                <SiDiscord className="hover:text-secondary-light transition-colors" />
            </a>
        </TooltipButton>
    );
};
